// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import Api from './Api';
import Element from 'element-ui';
import VueI18n from 'vue-i18n';
import 'element-ui/lib/theme-default/index.css';

Vue.prototype.$ajax = axios;
Vue.use(Element);
Vue.config.productionTip = false;
Vue.prototype.Api = Api;
Vue.use(VueI18n);

router.beforeEach(function (to, from, next) {
    if (to.path === '/login') {
        localStorage.removeItem('ACCESSTOKEN');
    }
    if (!localStorage.getItem('ACCESSTOKEN') && to.name !== 'login' && to.name !== '404') {
        next({
            path: '/login'
        });
    } else {
        Vue.prototype.$ajax.defaults.headers.common['Authorization'] = localStorage.getItem('ACCESSTOKEN');
        next();
    }
});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
        App
    },
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js